module.exports = __webpack_public_path__ + "static/loading_progress-8f40089626eccf809afd9dbb9c708cc1.gif";